import React from 'react'
import abimg from '../../images/resource/about-1.png'
import bg1 from '../../images/background/pattern-15.png'
import bg2 from '../../images/background/pattern-16.png'
import bg3 from '../../images/background/pattern-18.png'
import bg4 from '../../images/background/pattern-17.png'


const About2 = (props) => {
    return (
        <section className="about-two" id="about">
            <div className="about-two_pattern-one" style={{ backgroundImage: `url(${bg1})` }}></div>
            <div className="about-two_pattern-two" style={{ backgroundImage: `url(${bg2})` }}></div>
            <div className="about-two_pattern-three" style={{ backgroundImage: `url(${bg3})` }}></div>
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="about-two_content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="about-two_content-inner">
                            <div className="sec-title title-anim">
                                <div className="sec-title_title">Intention</div>
                                <h2 className="sec-title_heading">Discover The <br/> Best Version of Yourself</h2>
                                <div className="sec-title_text">Zentara is more than a just a vacation, it's a journey back to yourself. Curated by The Lush Minds, our immersive experiences blend mindful practices, natural healing, and authentic connections in some of the world's most stunning locations.</div>
                            </div>
                            <div className="about-two_options">
                                <ul className="about-two_options-list">
                                    <li><span className="icon fi flaticon-checked-1"></span><strong>Meaningful Connections:</strong> Share stories, skills, and experiences that go beyond networking.</li>
                                    <li><span className="icon fi flaticon-checked-1"></span><strong>Wellness & Growth:</strong> Gentle mindfulness, cultural immersion, and workshops designed to inspire clarity.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="about-two_image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="about-two_image-inner">
                            <div className="about-two_image titlt" data-tilt data-tilt-max="5">
                                <img src={abimg} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About2;